import { useEffect, useState, forwardRef, ReactElement } from "react";
import { useParams } from "react-router-dom";
import api from "../components/api";
import { useNavigate, Link } from "react-router-dom";
import toast, { Toaster } from 'react-hot-toast'


import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Slide from "@mui/material/Slide";
import { TransitionProps } from "@mui/material/transitions";


const Transition = forwardRef(function Transition(
    props: TransitionProps & { children: ReactElement<any, any> },
    ref
) {
    return <Slide direction="up" ref={ref} {...props} />;
});



const ResgataSenha = () => {

    const navigate = useNavigate();

    const { token, usuario_id } = useParams();

    const [novaSenha, setNovaSenha] = useState<string>('')
    const [confirmaSenha, setConfirmaSenha] = useState<string>('')
    const [nome, setNome] = useState<string>('')
    const [status, setStatus] = useState<string>('')

    const [open, setOpen] = useState(false)

    const [acao, setAcao] = useState<string>('')
    const [titulo, setTitulo] = useState<string>('')
    const [frase, setFrase] = useState<string>('')

    const validaResgataSenha = async () => {

        var dataPost = {
            usuario_id: usuario_id,
            token: token
        }

        //console.log(dataPost)
        //return false
        
        await api.post('validaResgataSenha', dataPost).then((response) => {

            
            
                if (response.data.status == 'ok') {
                    setStatus('ok')
                    setNome(response.data.nome)

                } else {
                    setStatus('erro')
                }
            
            }).catch((err) => {

                console.log(err.response)

            })

    }


    const validaNovaSenha = () => {
        
        if (novaSenha == '') {

            toast.error('Informe a nova senha!')
            return false

        }

        if (novaSenha != confirmaSenha) {
            toast.error('Senhas não conferem!')
        }

        setOpen(true)
        setAcao('salvar')
        setTitulo('Nova senha')
        setFrase('Deseja salvar a nova senha?')

    }


    const salvar = async () => {

        setOpen(false)
        
        var dataPost = {
            ad_usr: usuario_id,            
            senha: novaSenha
        }


        api.post(`usuarioAlteraSenha/${usuario_id}`, dataPost).then((response) => {
            
            if (response.data.status == 'ok') {
                toast.success('Senha alterada com sucesso!')
                navigate('/')                
            }

        }).catch((err) => {

            console.log(err.response)

        })


    }


    useEffect(() => {

        validaResgataSenha()
        
    }, [token, usuario_id])


    return (

        <div>

            <div className="bg-error">


                <div className="pt-5">
            
                    <div className="container pt-5">
                        <div className="row pt-5">
                            <div className="col-lg-12">
                                <div className="text-center error-pages">
                                    <img src="/assets/images/logo1.png" className="mb-4" width="175" alt="" />


                                    {

                                        status == 'erro' &&
                                        <div className="text-center">
                                            
                                            <br/>
                                            <p className="lead">

                                                Link inválido!
                                            </p>
                                            <br/>
                                        </div>

                                    }


                                    {
                                        status == 'ok' && 
                                        <div>
                                            <p className="mb-0">Olá <b>{nome}</b>, por favor informe suas novas credenciais abaixo:</p>

                                            <div className="w-50 py-4 mx-auto">

                                                <div className="input-group input-group-lg">
                                                <input type="password" className="form-control" placeholder="Nova senha" value={novaSenha} onChange={event => setNovaSenha(event.target.value)} />
                                                <input type="password" className="form-control" placeholder="Confirma senha" value={confirmaSenha} onChange={event => setConfirmaSenha(event.target.value)} />
                                                <button className="btn btn-success" type="button" onClick={validaNovaSenha}>Salvar
                                                </button>
                                                </div>

                                            </div>
                                        </div>

                                    }


                                            

                                    
                                    <div className="mt-4 d-flex align-items-center justify-content-center gap-3">
                                    <Link to='/' className="btn btn-info rounded-5 px-4"><i className="bi bi-key me-2"></i>Login</Link>
                                    
                                    </div>

                                    
                                    
                                </div>
                            </div>
                        </div>
                    </div>

                </div>


                
            </div>

            <Toaster
                position="top-right" // Posição no canto superior direito
                toastOptions={{
                    style: {
                        padding: "16px",
                        color: "#fff",
                    },
                    success: {
                        style: {
                            background: "#4caf50", // Verde
                        },
                    },
                    error: {
                        style: {
                            background: "#f44336", // Vermelho
                        },
                    },
                    loading: {
                        style: {
                            background: "#ff9800", // Laranja
                        },
                    },

                }}
            />


            <Dialog
                open={open}
                TransitionComponent={Transition}
                keepMounted
                onClose={() => setOpen(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth="xs"
                fullWidth
            >
                <DialogTitle id="alert-dialog-title">{titulo}</DialogTitle>
                <DialogContent sx={{ display: "flex", flexDirection: "column" }}>

                    <div style={{ textAlign: 'justify' }}>
                        {frase}
                    </div>

                </DialogContent>
                <DialogActions>


                    <Button color="error" variant="contained" onClick={() => setOpen(false)} style={{ display: acao == 'salvar' ? 'table-row' : 'none' }}>
                        Cancelar
                    </Button>
                    <Button color="success" variant="contained" onClick={() => salvar()} style={{ display: acao == 'salvar' ? 'table-row' : 'none' }}>
                        Ok
                    </Button>


                </DialogActions>
            </Dialog>

        </div>

    )

}

export default ResgataSenha